
import {Vue, Component, Prop} from 'vue-property-decorator'
import BillDetailHeaderCard from "@/views/pays/components/BillDetailHeaderCard.vue";
import api from "@/api";
import {SplitBillStatisticsDto} from "@/api/appService";

@Component({
  name: 'BillDetailHeader',
  components: {BillDetailHeaderCard}
})
export default class BillDetailHeader extends Vue {

  @Prop({required: true})
  billId!: number

  @Prop({required: true})
  billDate!: string;

  loading = true;

  dto: SplitBillStatisticsDto = {
    storeReceivedAmount: 0,
    refundAmount: 0,
    billDate: '',
    totalAmount: 0,
    orderCount: 0,
    wechatFeePercent: 0,
    allianceBusinessAmount: 0
  }

  mounted() {
    api.splitBill.getBillStatistics({billId: this.billId}).then(res => {
      Object.assign(this.dto, res)
      this.loading = false
    })
  }

}
